<template>
  <div class="vue-template">
    <router-view />
    <!-- Navigation -->
    <nav v-if="$store.state.login" class="navbar justify-content-between flex-nowrap flex-row fixed-top">
      <div class="container">
        <b-link class="nav-link pr-3 navbar-brand float-left" :href="ariannaURL"/>
        <ul v-if="!mobile" class="nav navbar-nav flex-row float-left">
          <!-- <li class="nav-item">
            <b-link class="nav-link pr-3" to="/">Home</b-link>
          </li> -->
          <li class="nav-item">
            <b-link class="nav-link pr-3" to="/sellout/file" @click="$store.commit('disableFileFormat'); $store.commit('enableSend');" :active='$route.name == "file"'>Caricamento da file dei prodotti</b-link>
          </li>
          <li class="nav-item">
            <b-link class="nav-link pr-3" to="/sellout/manual" @click="$store.commit('disableFileFormat');" :active='$route.name == "manual"'>Inserimento manuale dei prodotti</b-link>
          </li>
        </ul>
        <b-dropdown v-else id="mobile-menu" left toggle-class="text-decoration-none user-sub" no-caret>
          <template #button-content>
            <b-icon icon="list" scale="1.5"></b-icon>
          </template>
          <b-dropdown-item to="/sellout/file">Caricamento da file dei prodotti</b-dropdown-item>
          <b-dropdown-item to="/sellout/manual">Inserimento manuale dei prodotti</b-dropdown-item>
        </b-dropdown>
      </div>
      <div>
        <ul class="nav navbar-nav flex-row float-right">
          <li class="nav-item">
            <span style="white-space:nowrap">
              <label class="bookshop-name">{{ entity ? entity.name : "" }}</label>
              <b-dropdown id="user-sub" right toggle-class="text-decoration-none user-sub" no-caret>
                <template #button-content>
                  <b-icon icon="person-fill" scale="1.5"></b-icon>
                </template>
                <b-dropdown-item v-if ="entity && entity.encodedGUID" :href="'https://www.ie-online.it/ModuloLibreria/entity/' + entity.encodedGUID" target="_blank">Anagrafica</b-dropdown-item>
                <b-dropdown-item @click="logout()">Disconnettiti</b-dropdown-item>
              </b-dropdown>
            </span>
          </li>
          <li v-if="!$store.state.login" class="nav-item">
            <b-link class="nav-link pr-3" to="/login" :active='$route.name == "login"'>Accedi</b-link>
          </li>
          <!-- <li v-else class="nav-item">
            <b-link class="nav-link pr-3" @click="logout()">Disconnettiti</b-link>
          </li> -->
        </ul>
      </div>
    </nav>

    <b-modal ref="unauthorized" centered hide-footer title="Utente non autorizzato" size="m" @hide="$keycloak.logout();">
      <b-row class="text-center mb-3"><b-col><span class="content-label">Non sei autorizzato ad accedere a questa sezione del sito.</span></b-col></b-row>
      <b-row class="spacing"></b-row>
      <b-row class="text-center">
        <b-col>
          <b-button class="btn btn-purple btn-sm mr-3" @click="closeModal('unauthorized'); $keycloak.logout();">Ok</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  import http from "./axios/http-api";
  http.defaults.withCredentials = true;
  //http.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
  import router from './router';
  //import * as cookies from 'tiny-cookie';

  export default {
    name: 'App',
    data() {
      return {
        ariannaURL: process.env.VUE_APP_ARIANNA_URL,
        entity: null,
        mobile: false
      }
    },
    components: {
    },
    created() {
      this.mobile = screen.width <= 991;
    },
    mounted() {
      this.$store.dispatch('setKeycloakToken', this.$keycloak.token);
      /*if (!cookies.getCookie("JSESSIONID")) {
        router.push({name: 'login'});
      } else {
        this.$store.commit('login');
      }*/
      this.getUser();
    },
    methods: {
      failed: function(err) {
        this.$store.commit('hideLoading');
        if (err.response && (err.response.status == "400" || err.response.status == "405")) {
            var alert = {
              message: "La sessione è scaduta. Effettua di nuovo il login.",
              variant: 'danger',
              dismissSecs: 5
            };
            this.$store.commit('hideFlow');
            this.$store.commit('hideAlibi');
            this.$store.commit('hidePromotion');
            this.$store.commit('hideForm');
            router.push({name: 'login', params: {alert: alert}});
        } else {
          console.log(err);
          alert = {
            message: "Si è verificato un errore, si prega di riprovare. Se il problema persiste contattare un tecnico.",
            variant: 'danger',
            dismissSecs: 30
          };
          this.$emit('showAlert', alert);
        }
      },
      openModal: function (modal) {
        this.$refs[modal].show();
      },
      closeModal: function (modal) {
        this.$refs[modal].hide();
      },
      logout: function() {
        /*this.$store.commit('logout');
        cookies.removeCookie("JSESSIONID");
        router.push({name: 'login'});*/
        this.$store.dispatch('setKeycloakToken', null);
        //var logoutOptions = { redirectUri : 'arianna.org' };
        this.$keycloak.logout();
      },
      getBookshop: function() {
        var uri = '/alibi/' + this.$store.state.user.eanLocationCode;
        let config = {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.keycloakToken
          }
        };
        http.get(uri,config)
        .then(res => {
          // do something with res
          //console.log("Ho avuto una risposta!");
          //(res.data);
          this.entity = res.data;
          this.$store.dispatch('setEntity', res.data);
        })
        .catch(err => {
          this.failed(err);
        });
      },
      getUser: function() {
        var uri = '/user';
        let config = {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.keycloakToken
          }
        };
        http.get(uri,config)
        .then(res => {
          // do something with res
          //console.log("Ho avuto una risposta!");
          //console.log(res);
          if (res.data) {
            this.$store.dispatch('setUser', res.data);
            this.getBookshop();
          } else {
            this.openModal('unauthorized');
          }
        })
        .catch(err => {
          this.failed(err);
        });
      }
    }
  }
</script>

<style>
  @media (min-width: 1200px) {
    .container {
      max-width: 100% !important;
    }
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  * {
    box-sizing: border-box;
  }
  body {
    /*background: #c0c1c2 !important;*/
    background: url("https://arianna.org/img/header-bg.jpg"); /*linear-gradient(87deg,#172b4d,#1a174d) !important;*/
    background-size: cover;
    background-position: center center;
    min-height: 100vh;
    display: flex;
    font-weight: 400;
  }
  body,
  html,
  .App,
  .vue-template,
  .vertical-center {
    width: 100%;
    height: 95%;
  }
  .btn-purple {
    background-color: #B6004F !important;
  }
  .button-center {
    display: flex;
    text-align: left;
    justify-content: center;
    flex-direction: column;
    height: 110%;
  }
  .button-inner-block {
    /*width: 450px;*/
    margin: auto;
  }

  .btn-lg, .btn-group-lg > .btn {
    padding: 0.15rem 1rem !important;
  }
  .form-control, .custom-select {
    color: #000 !important;
  }
  .loader-wrapper {
    right: 50vw !important;
    bottom: 50vh !important;
  }
  .navbar {
    background-color: #F39517;
    box-shadow: 0 .25rem .25rem rgba(0,0,0,.25),inset 0 -1px 5px rgba(0,0,0,.25);
  }
  .navbar .navbar-nav .nav-link {
      padding-right: .5rem;
      padding-left: .5rem;
      color: #000;
  }
  .navbar .navbar-nav .nav-link.router-link-exact-active {
      font-weight: 600;
  }
  .navbar .navbar-nav .nav-link.router-link-exact-active, .navbar .navbar-nav .nav-link:hover {
      color: #fff;
      background-color: transparent;
  }
  .navbar .container {
    display: block !important;
  }
  .navbar-brand {
    background-image: url("https://arianna.org/img/arianna.png");
    background-repeat: no-repeat;
    background-size: 50px; 
    height: 40px;
    width: 50px;
    margin-right: 2rem !important;
  }
  .bookshop-name {
    color: #000;
  }
  .table.b-table,
  .content-box,
  .vue-map-container,
  #supplier-container .card {
    -webkit-box-shadow: 7px 7px 10px rgba(0, 0, 0,0.5);
    -moz-box-shadow: 7px 7px 10px rgba(0, 0, 0,0.5);
    box-shadow: 7px 7px 10px rgba(0, 0, 0,0.5);
  }
  .btn:not(a):not(.activity-button):not(.user-sub):not(.b-form-datepicker .btn) {
    -webkit-box-shadow: 2px 2px 3px rgba(0, 0, 0,0.5) !important;
    -moz-box-shadow: 2px 2px 3px rgba(0, 0, 0,0.5) !important;
    box-shadow: 2px 2px 3px rgba(0, 0, 0,0.5) !important;
  }
  .no-shadow {
    -webkit-box-shadow: 0 !important;
    -moz-box-shadow: 0 !important;
    box-shadow: 0 !important;
  }
  .table.b-table thead,
  #supplier-container .card .card-header {
    background: linear-gradient(to right, cornflowerblue, #B1C9E8);
    /*background: linear-gradient(to right, #c16519, #e9ab6c);*/
    /*background-color: #e9ab6c;*/
  }
  input, select, textarea, label::before, .b-form-datepicker, .input-group-text, .select-all, .pagination li span, .pagination li button, .custom-file-label {
    -webkit-box-shadow: 1px 1px 2px rgba(0, 0, 0,0.5);
    -moz-box-shadow: 1px 1px 2px rgba(0, 0, 0,0.5);
    box-shadow: 1px 1px 2px rgba(0, 0, 0,0.5);
  }
  select, label::before, label::after {
    cursor: pointer;
  }
  select:disabled, button:disabled, .custom-control-input:disabled ~ .custom-control-label::after {
    cursor: not-allowed;
  }
  .b-table-top-row input {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  label, legend {
    /*text-shadow:1px 1px 1px #000;*/
    font-weight: bold;
  }
  div.accordion-title {
    font-size: 20px;
    font-weight: bold;
  }
  .btn:not(a):not(.activity-button):not(.user-sub) {border:0;border-bottom:0;border-left:0;/*font-weight:'900';font-family:'Ubuntu', sans-serif;*/box-shadow: inset 0 -3.2px rgba(0, 0, 0, 0.12),inset 2px 0 rgba(0, 0, 0, 0.1);outline:none;-webkit-outline:none;-o-outline:none;-moz-outline:none;}
  .btn:active:not(a):not(.activity-button):not(.user-sub), .btn.active:not(.activity-button):not(.user-sub) {outline:none;-moz-outline:none;background-image: none;-webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125) !important;position: relative;box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125) !important;top: 1px;left:-1px;}
  .btn:focus:not(a):not(.user-sub) {outline:none;-webkit-outline:none;-moz-outline:none;}
  #main-tab .nav-link {
    font-weight: bold;
    border-color: #dee2e6 !important
  }
  #main-tab .nav-link.active {
    font-weight: bold;
    color: #fff !important;
    background-color: cornflowerblue !important;
    border-bottom-color: cornflowerblue !important;
  }
  .user-sub {
    color: #ffd49b !important;
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: 0 0 0 0 !important;
  }
  .user-sub:hover {
    color: #fff !important;
  }
  .content-box-label {
    position: relative;
    display: block;
    top: -16px;
    background: white;
    padding: 0 5px;
    font-weight: bold;
    font-size: 18px;
  }
  .custom-file-label {
    cursor: pointer;
  }
  .b-form-tag {
    padding: 5px 10px !important;
    font-size: 100% !important;
  }
  .b-form-tag > button.b-form-tag-remove {
    display: none;
  }
  #main-tab .card-header {
    background-color: #fff;
  }
  .text-red {
    color: red;
    border: 1px solid red;
  }
</style>
